enum SubmissionStatus {
  DRAFT,
  SUBMITTED,
}

enum ActivitySubmissionStatus {
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
}

enum LogAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export { SubmissionStatus, LogAction,ActivitySubmissionStatus };
